"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _axios = _interopRequireDefault(require("axios"));
var _jsCookie = _interopRequireDefault(require("js-cookie"));
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
var Hubspot = /*#__PURE__*/_createClass(function Hubspot(hubspot) {
  var _this = this;
  _classCallCheck(this, Hubspot);
  this.hubspotSubmitForm = function (formId) {
    var fields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (!_this.hubspot.shouldSync) return;
    var url = "https://api.hsforms.com/submissions/v3/integration/submit/".concat(_this.hubspot.platformId, "/").concat(formId);
    var data = {
      fields: Object.keys(fields).map(function (key) {
        return {
          name: key,
          value: fields[key] || ''
        };
      }),
      context: {
        hutk: _jsCookie.default.get('hubspotutk')
      }
    };
    return _axios.default.post(url, data);
  };
  this.hubspotSubmitLeadCapture = function (email) {
    return function () {
      return _this.hubspotSubmitForm(_this.hubspot.signUpFormId, {
        email: email
      });
    };
  };
  this.hubspotSubmitNewsletterSignup = function (email) {
    return function () {
      return _this.hubspotSubmitForm(_this.hubspot.newsletterFormId, {
        email: email
      });
    };
  };
  this.hubspotSubmitCmeCoach = function (email) {
    return function (dispatch, getState) {
      var _getState = getState(),
        cmeCoach = _getState.cmeCoach,
        staticData = _getState.staticData;
      var fields = {
        email: email,
        cme_coach_specialty_1: staticData.getIn(['specialties', cmeCoach.get('searchedSpecialtyId'), 'name']) || '',
        cme_coach_state_1: staticData.getIn(['us_states', cmeCoach.get('searchedStateId'), 'name']) || ''
      };
      return _this.hubspotSubmitForm(_this.hubspot.cmeCoachFormId, fields);
    };
  };
  this.hubspotSubmitInstitutionalLanding = function (data) {
    return _this.hubspotSubmitForm(_this.hubspot.institutionalLandingFormId, data);
  };
  this.hubspot = hubspot;
});
var _default = exports.default = Hubspot;